"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setQueryType = exports.setCountryCode = exports.setPhone = exports.setEmail = exports.setComment = exports.setMembers = exports.setSource = exports.setEnquiry = exports.setDate = exports.registerEnquiry = exports.setRegistering = exports.getUserDetails = exports.prevStep = exports.lastStep = exports.nextStep = exports.setUserDetails = exports.parseJSON = exports.checkStatus = void 0;

var _constant = require("./constant");
/* eslint-disable no-undef */


var checkStatus = function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  var error = {
    status_code: response.status,
    status_text: response.statusText,
    data: response.json()
  };
  throw error;
};

exports.checkStatus = checkStatus;

var parseJSON = function parseJSON(response) {
  return response.json();
};

exports.parseJSON = parseJSON;

var setUserDetails = function setUserDetails(userDetails) {
  return {
    type: _constant.USER_DETAILS,
    payload: userDetails
  };
};

exports.setUserDetails = setUserDetails;

var nextStep = function nextStep() {
  return {
    type: _constant.NEXT_STEP
  };
};

exports.nextStep = nextStep;

var lastStep = function lastStep() {
  return {
    type: _constant.LAST_STEP
  };
};

exports.lastStep = lastStep;

var prevStep = function prevStep() {
  return {
    type: _constant.PREV_STEP
  };
};

exports.prevStep = prevStep;

var getUserDetails = function getUserDetails(id) {
  var formData = new FormData();
  formData.append("id", id);
  return function (dispatch) {
    return fetch("".concat(_constant.API_ROOT, "getUserDataById.php"), {
      method: "POST",
      credentials: "same-origin",
      body: formData
    }).then(checkStatus).then(parseJSON).then(function (data) {
      if (data.status) {
        return dispatch(setUserDetails(data.payload));
      }

      return false;
    }).catch(function (error) {
      console.log(error);
    });
  };
};

exports.getUserDetails = getUserDetails;

var setRegistering = function setRegistering(bool) {
  return {
    type: _constant.REGISTER_ENQUIRY_LOADER,
    payload: bool
  };
};

exports.setRegistering = setRegistering;

var registerEnquiry = function registerEnquiry(enquiry, date, members, comment, source, user, email, phone, countryCode) {
  var formData = new FormData();
  formData.append("user_id", user.id);
  formData.append("first_name", user.first_name);
  formData.append("last_name", user.last_name);
  formData.append("email", email);
  formData.append("phone", phone);
  formData.append("countryCode", countryCode);
  formData.append("source", source);
  formData.append("id", enquiry.id);
  formData.append("queryType", enquiry.queryType);
  formData.append("startDate", date.startDate);
  formData.append("endDate", date.endDate);
  formData.append("dateType", date.dateType);
  formData.append("nrAdults", members.nrAdults);
  formData.append("nrChild", members.nrChild);
  formData.append("comment", comment);
  return function (dispatch) {
    dispatch(setRegistering(true));
    return fetch("".concat(_constant.API_ROOT, "registerEnquiry_new.php"), {
      method: "POST",
      credentials: "same-origin",
      body: formData
    }).then(checkStatus).then(parseJSON).then(function (data) {
      console.log(data);
      return dispatch(lastStep());
    }).catch(function (error) {
      console.log(error);
    });
  };
};

exports.registerEnquiry = registerEnquiry;

var setDate = function setDate(date) {
  return {
    type: _constant.DATE,
    payload: date
  };
};

exports.setDate = setDate;

var setEnquiry = function setEnquiry(enquiry) {
  return {
    type: _constant.ENQUIRY_FOR,
    payload: enquiry
  };
};

exports.setEnquiry = setEnquiry;

var setSource = function setSource(source) {
  return {
    type: _constant.SOURCE,
    payload: source
  };
};

exports.setSource = setSource;

var setMembers = function setMembers(members) {
  return {
    type: _constant.MEMBERS,
    payload: members
  };
};

exports.setMembers = setMembers;

var setComment = function setComment(comment) {
  return {
    type: _constant.COMMENT,
    payload: comment
  };
};

exports.setComment = setComment;

var setEmail = function setEmail(email) {
  return {
    type: _constant.EMAIL,
    payload: email
  };
};

exports.setEmail = setEmail;

var setPhone = function setPhone(phone) {
  return {
    type: _constant.PHONE,
    payload: phone
  };
};

exports.setPhone = setPhone;

var setCountryCode = function setCountryCode(countryCode) {
  return {
    type: _constant.COUNTRY_CODE,
    payload: countryCode
  };
};

exports.setCountryCode = setCountryCode;

var setQueryType = function setQueryType(query) {
  return {
    type: _constant.QUERY_TYPE,
    payload: query
  };
};

exports.setQueryType = setQueryType;